// The portal's calls to /api/contacts (features/contact): shapes from packages/contracts, the
// same the v3 API answers with.
import { ContactListResponse, ContactResponse, type ContactInput } from "@kilat/contracts/contact";
import { api } from "@/lib/api-client";

export const CONTACTS_PER_PAGE = 25;

export const listContacts = (page: number) =>
  api.request(`/api/contacts?page=${page}&per_page=${CONTACTS_PER_PAGE}`, { schema: ContactListResponse });

export const getContact = (contactId: string) => api.request(`/api/contacts/${contactId}`, { schema: ContactResponse });

export const createContact = (input: ContactInput) =>
  api.request("/api/contacts", { method: "POST", body: input, schema: ContactResponse });

export const updateContact = (contactId: string, input: ContactInput) =>
  api.request(`/api/contacts/${contactId}`, { method: "PUT", body: input, schema: ContactResponse });
